import { set } from '../../utils/cookies'
import { queryString, path } from '../../utils/window'

export default function setLocaleCookie() {
  if (queryString.setLocale) {
    set('locale', path.substr(1), { path: '/', expires: new Date('2020', '1', '1') })
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/localeCookieInitializer.js